// The base IP address of the wireless access point's HTTP API, operating on port 888
export const BASE_IPV4_ADDRESS = 'http://172.26.48.1:888';
